import * as React from 'react';
import CollapsibleCard from '../../../../common/CollapsibleCard';
import FormInput from '../../../../common/form/Input';
import { AccessType, StratisPropertyConfiguration } from '../../../../../api/PropertyIntegration';
import FormSelectLabeled from '../../../../common/form/SelectLabeled';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../../utilities/identity';

interface Props {
    config?: StratisPropertyConfiguration;
    update: (newConfig?: StratisPropertyConfiguration) => void;
}

const StratisConfigurationSection = (props: Props) => {
    const isUser =
    userIsCompanyManageUser() ||
    userIsPropertyManageUser() ||
    userIsSystemManageUser();
    return(
    <CollapsibleCard
        cardTitle="Stratis SmartHome Access"
        cardOpen={!!props.config}
        onCardOpenChange={open =>{
            if (isUser)  return;
            props.update(
                open
                    ? {
                        stratisPropertyId: '', suppressButterflyMX: false, usesBrivo: false,
                        stratisAccessType: AccessType.BOTH, isYaleEnabled: false
                    }
                    : undefined
            )
        }}
    >
        <div>
            {props.config && (
                <>
                    <FormInput
                        labelProps={{
                            labelText: 'Property ID',
                            invalidText: 'Please enter a Stratis Property ID'
                        }}
                        inputProps={{
                            id: 'stratis-property-id',
                            name: 'stratisPropertyId',
                            value: props.config.stratisPropertyId,
                            type: 'string',
                            required: true,
                            disabled: isUser
                        }}
                        onChange={(_name, value) =>
                            !isUser && props.update({ ...props.config!, stratisPropertyId: value.toString() })
                        }
                    />
                    <FormSelectLabeled
                        labelProps={{
                            labelText: 'ButterflyMX Enabled'
                        }}
                        selectProps={{
                            id: 'bmx-enable',
                            name: 'enableButterflyMX',
                            value: !props.config.suppressButterflyMX,
                            required: true,
                            disabled: isUser
                        }}
                        selectOptions={[
                            { value: true, label: 'Yes' },
                            { value: false, label: 'No' }
                        ]}
                        onChange={(_name, value) =>
                            !isUser && props.update({ ...props.config!, suppressButterflyMX: !value })
                        }
                    />
                    <FormSelectLabeled
                        labelProps={{
                            labelText: 'Brivo Enabled'
                        }}
                        selectProps={{
                            id: 'brivo-enable',
                            name: 'enableBrivo',
                            value: props.config.usesBrivo,
                            required: true,
                            disabled: isUser
                        }}
                        selectOptions={[
                            { value: true, label: 'Yes' },
                            { value: false, label: 'No' }
                        ]}
                        onChange={(_name, value) =>
                            !isUser && props.update({ ...props.config!, usesBrivo: !!value })
                        }
                    />
                    <FormSelectLabeled
                        labelProps={{
                            labelText: 'Access Type'
                        }}
                        selectProps={{
                            id: 'stratis-access-type',
                            name: 'stratisAccessType',
                            value: props.config.stratisAccessType,
                            required: true,
                            disabled: isUser
                        }}
                        selectOptions={[
                            { value: AccessType.MOBILE, label: 'Mobile' },
                            { value: AccessType.PINCODE, label: 'Pincode' },
                            { value: AccessType.BOTH, label: 'Both' }
                        ]}
                        onChange={(_name, value) =>
                            !isUser && props.update({
                                ...props.config!, stratisAccessType:
                                    typeof (value) === 'string' ? parseInt(value, 10) :
                                        typeof (value) === 'number' ? value : AccessType.BOTH
                            })
                        }
                    />
                    <FormSelectLabeled
                        labelProps={{
                            labelText: 'Yale Enabled'
                        }}
                        selectProps={{
                            id: 'yale-enable',
                            name: 'enableYale',
                            value: props.config.isYaleEnabled,
                            required: true,
                            disabled: isUser
                        }}
                        selectOptions={[
                            { value: true, label: 'Yes' },
                            { value: false, label: 'No' }
                        ]}
                        onChange={(_name, value) =>
                            !isUser && props.update({ ...props.config!, isYaleEnabled: !!value })
                        }
                    />
                </>
            )}
        </div>
    </CollapsibleCard>
);
};
export default StratisConfigurationSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/StratisConfigurationSection.tsx